<template>
  <form @submit.prevent="warehouseAction">
    <div class="mb-3">
      <label>Name</label>
      <input
          v-model="warehouse.name"
          name="name"
          type="text"
          class="form-control"
          :class="{
            'is-invalid': v$.warehouse.name.$error,
          }"
      />
      <p
          v-for="error of v$.warehouse.name.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="mb-3">
      <label>Location</label>
      <vue-google-autocomplete id="map" classname="form-control py-3" placeholder="Search location" country="ke" types="establishment"
                               v-on:placechanged="getAddressData"></vue-google-autocomplete>
    </div>
    <div class="mb-3">
      <label>Description</label>
      <textarea
          v-model="warehouse.description"
          class="form-control"
          :class="{
            'is-invalid': v$.warehouse.description.$error,
          }"
          rows="5"
      ></textarea>
      <p
          v-for="error of v$.warehouse.description.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div v-for="(error, index) in stockErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>
    <div class="mt-3 col-12">
      <b-button variant="primary" size="lg" class="py-3 h3 w-100" disabled v-if="stockLoading">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button variant="primary" size="lg" class="py-3 h3 w-100 text-white" type="submit" v-else>
        {{ button_text }}
      </b-button>
    </div>
  </form>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import {mapGetters} from "vuex";
export default {
name: "new-warehouse-form-component",
  components: {VueGoogleAutocomplete},
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      address: {
        longitude: this.selected_warehouse.longi,
        latitude: this.selected_warehouse.lat
      },
      warehouse: this.selected_warehouse
    }
  },
  props: {
    selected_warehouse: {
      type: Object,
      default(){
        return {
          name: "",
          description: "",
          lat: "",
          longi: "",
        }
      }
    },
    button_text: {type: String}
  },
  validations () {
    return {
      warehouse: {
        name: {required},
        description: {required}
      }
    }
  },
  computed: {
    ... mapGetters({
      stockLoading: 'stock/stockLoading',
      stockErrors: 'stock/stockErrors'
    }),
  },
  methods: {
    getAddressData: function (addressData) {
      this.address = addressData;
    },

    async warehouseAction() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const data = {
        name: this.warehouse.name,
        description: this.warehouse.description,
        longi: String(this.address.longitude),
        lat: String(this.address.latitude),
        isDefaultWarehouse: false
      }

      this.$emit('warehouseAction', data)
      this.v$.$touch();
    }
  }
}
</script>

<style scoped>

</style>
